import React from 'react';

/**
 * Pill: compact status label.
 * Colours come from the status table in .kiro/steering/ui-design-system.md.
 * Every text/background pair below is at least 4.5:1 (WCAG AA).
 * Light theme only.
 */
export type PillTone =
  | 'success' // pass, accepted, matches, high
  | 'warning' // curable, medium
  | 'danger' // fail, material, mismatch, low
  | 'neutral' // not run, informational
  | 'selected'; // selected, edited

export const PILL_TONE_CLASSES: Record<PillTone, string> = {
  success: 'bg-[#dcfce7] text-[#166534]',
  warning: 'bg-[#fef9c3] text-[#854d0e]',
  danger: 'bg-[#fee2e2] text-[#991b1b]',
  neutral: 'bg-[#f3f4f6] text-[#4b5563]',
  selected: 'bg-[#EDE7FF] text-[#5A21C9]',
};

export interface PillProps {
  tone?: PillTone;
  children: React.ReactNode;
  /** Optional leading icon (lucide-react, 12-14px). */
  icon?: React.ReactNode;
  title?: string;
  className?: string;
}

export const Pill: React.FC<PillProps> = ({
  tone = 'neutral',
  children,
  icon,
  title,
  className = '',
}) => (
  <span
    title={title}
    className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-bold whitespace-nowrap ${PILL_TONE_CLASSES[tone]} ${className}`.trim()}
  >
    {icon}
    {children}
  </span>
);

export default Pill;
